import {
  // GET_DEALS_FAILURE,
  GET_DEALS_REQUEST,
  GET_DEALS_SUCCESS,
  GET_DEALS_TIMEOUT
} from '../constants/ActionTypes';

// import { dispatchError, cachedFetchGet } from '../utils/fetch';
// import { format } from 'date-fns';
// import { parseISOLocal } from '../utils/date';
// import { first } from '../utils';
// import packageKey from '../utils/packageKey';

function getDealsRequest(day) {
  return {
    type: GET_DEALS_REQUEST,
    day
  };
}

// function getDealsFailure(day, error, errors) {
//   return {
//     type: GET_DEALS_FAILURE,
//     day,
//     error,
//     errors
//   };
// }

function getDealsSuccess(day, deals) {
  return {
    type: GET_DEALS_SUCCESS,
    day,
    deals,
    date: new Date(),
    timeout: setTimeout(getDealsTimeout, 5000)
  };
}

function getDealsTimeout() {
  return {
    type: GET_DEALS_TIMEOUT
  };
}

export default function getDeals() {
  return (dispatch, getState) =>
    new Promise(resolve => {
      const {
        sale: {
          sale: { day }
        }
      } = getState();

      dispatch(getDealsRequest(day));
      dispatch(getDealsSuccess(day, []));
      resolve();
    });
}
